import { useQuery } from '@tanstack/react-query';
import { useUser } from '@/hooks/useUser';
import { queryFn } from './queryFn';

export const getQueryKey = (userId: string): [string, string | undefined] => [
  'USER_NOTES',
  userId,
];

export const useUserNotes = () => {
  const { data: user } = useUser();
  return useQuery({
    queryKey: getQueryKey(user.id),
    queryFn,
    enabled: user.loggedIn && typeof user !== 'undefined',
    staleTime: 3600000,
    retry: 1,
  });
};
